import { httpService } from '@/utils/httpService';
import type { ConversationResponse, DBConversationResponse } from '@/types/api';

const startInterview = async (
  conversationId: string,
  needsRecording: boolean
): Promise<ConversationResponse> => {
  const search = needsRecording ? '?recording=true' : '';
  return httpService.post<ConversationResponse>(
    `/conversations/start-interview/${conversationId}${search}`
  );
};

const stopInterview = async (
  conversationId: string
): Promise<ConversationResponse> => {
  return httpService.post<ConversationResponse>(
    `/conversations/stop-interview/${conversationId}`
  );
};

const getConversationsByAssignmentId = async (
  assignmentId: string
): Promise<DBConversationResponse[]> => {
  return httpService.get<DBConversationResponse[]>(
    `/conversations/assignments/${assignmentId}`
  );
};

const getConversationsByAssignmentIdWithTranscripts = async (
  assignmentId: string
): Promise<DBConversationResponse[]> => {
  return httpService.get<DBConversationResponse[]>(
    `/conversations/assignments/${assignmentId}/with-transcripts`
  );
};

export const conversationService = {
  startInterview,
  stopInterview,
  getConversationsByAssignmentId,
  getConversationsByAssignmentIdWithTranscripts,
} as const;
